///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import queryString from "query-string";
import { omitBy, isNil } from "lodash";

import types from "./types";

export const setFilterQueryStringParameters = (history, filters) => {
  const filteredParams = omitBy(filters, isNil);
  const currentRoute = getCurrentRoute();
 
  /* Only search for search term on tracking page - OLD CODE re-added */
  let params = filteredParams;
  if (currentRoute === types.appRoutes.tracking && filteredParams.searchTerm) {
    params = {
      searchTerm: filteredParams.searchTerm,
      currentPage: filteredParams.currentPage,
      sortDirection: filteredParams.sortDirection,
    };

    if (filteredParams.sortColumn) {
      params.sortColumn = filteredParams.sortColumn;
    }
    else if (filteredParams.sortType) {
      params.sortType = filteredParams.sortType;
    }
    else {
      params = {
        searchTerm: filteredParams.searchTerm,
        currentPage: filteredParams.currentPage,
      };
    }
  }

  const queryStringParameters = queryString.stringify(params);

  /* END - Only search for search term on tracking page */

  /* Search for everything on tracking page ...
  const queryStringParameters = queryString.stringify(filteredParams);
  */ 

  history.push({
    search: `?${queryStringParameters}`,
  });
};

export const getFiltersFromQueryStringParameters = () => {
  let params = queryString.parse(window.location.search);
  const currentRoute = getCurrentRoute();
  if (currentRoute === types.appRoutes.tracking ||
    currentRoute === types.appRoutes.availableroutes) {
    params = {
      ...params,
      currentPage: params.currentPage ? parseInt(params.currentPage, 10) : 0,
      alertsOnly: params.alertsOnly ? params.alertsOnly == "true" : false,
    };
  } else if (currentRoute === types.appRoutes.availableroutes) {
    params = {
      ...params,
      currentPage: params.currentPage ? parseInt(params.currentPage, 10) : 0,
      spotLegId: params.spotLegId ?? null,
    };
  } else {
    params = {
      ...params,
      currentPage: params.currentPage ? parseInt(params.currentPage, 10) : 0,
    };
  }
  return params;
};

export const getIsGoTrack = () => {
  return window.location.pathname.split("/")[1] === "tracking";
};

export const getCurrentRoute = () => {
  if (window.location.pathname.split("/")[1] === types.appRoutes.tracking) {
    return types.appRoutes.tracking;
  } else if (
    window.location.pathname.split("/")[1] === types.appRoutes.availableroutes
  ) {
    return types.appRoutes.availableroutes;
  } else if (
    window.location.pathname.split("/")[1] === types.appRoutes.userManagement
  ) {
    return types.appRoutes.userManagement;
  } else if (
    window.location.pathname.split("/")[1] === types.appRoutes.carrierManagement
  ) {
    return types.appRoutes.carrierManagement;
  }
};
